import { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
// mui icons
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Button, TextField } from '@mui/material';
import { CursoState } from '../../../../store/slices/curso';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { SeccionState } from '../../../../store/slices/seccion';
import { actualizarSeccionEjercicio, crearSeccionEjercicio } from '../../../../store/slices/seccion-ejercicio';

type Props = {
  curso: CursoState,
  seccion: SeccionState,
  tipo: string
  setOpen: any
}

const FormularioEditarSM = ({ curso, seccion, tipo, setOpen }: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { ejercicio } = useSelector((state: RootState) => state.seccionEjercicio);


  const [letra, setLetra] = useState(ejercicio.alternativas.find(item => item.estado === true)!== undefined ? ejercicio.alternativas.find(item => item.estado === true)?.letra : '');
  const [enunciado, setEnunciado] = useState(ejercicio.enunciado);


  const [alternativas, setAlternativas] = useState(ejercicio.alternativas);

  useEffect(() => {
    if (letra !== '') {
      setAlternativas(alternativas.map(item => item.letra === letra ? { ...item, estado: true } : { ...item, estado: false }))
    }
  }, [letra, alternativas])

  const handleEditarEjercicio = () => {

    const letras = []

    for (let k = 0; k < alternativas.length; k++) {
      const element = alternativas[k];
      if (element.alternativa !== '') {
        letras.push(true)
      }
    }

    if (enunciado !== '' && letras.filter(Boolean).length === 4 && letra !== '') {
      const actualizadoEjercicio = {
        eid: ejercicio.eid,
        cid: ejercicio.cid,
        mid: ejercicio.mid,
        bid: ejercicio.bid,
        sid: ejercicio.sid,
        numero: ejercicio.numero,
        tipo: tipo, 
        enunciado: enunciado, 
        respuesta: '', 
        alternativas: alternativas, 
        variable: ''
      }

      dispatch(actualizarSeccionEjercicio(actualizadoEjercicio));
      setOpen(false);
    }
  }

  return (
    <div className="p-3">
      <div className="row">
        <div className="col-12">
          <h4>Editar Ejercicio</h4>
        </div>
      </div>

      <TextField
        sx={{ mb: 1 }}
        autoFocus
        margin="dense"
        id="name"
        label="Enunciado del Ejercicio"
        multiline
        rows={10}
        fullWidth
        variant="outlined"
        value={enunciado}
        onChange={(e: any) => setEnunciado(e.target.value)}
        autoComplete="off"
      />

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('A')}>
          {
            letra === 'A' ?
              <RadioButtonCheckedIcon color='primary' /> :
              <RadioButtonUncheckedIcon color='primary' />
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          multiline={true}
          placeholder="Alternativa (A)"
          value={alternativas.find(item => item.letra === 'A')?.alternativa}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'A'), { alternativa: e.target.value, letra: 'A', estado: (letra === 'A' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('B')}>
          {
            letra === 'B' ?
              <RadioButtonCheckedIcon color='primary' /> :
              <RadioButtonUncheckedIcon color='primary' />
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          multiline={true}
          placeholder="Alternativa (B)"
          value={alternativas.find(item => item.letra === 'B')?.alternativa}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'B'), { alternativa: e.target.value, letra: 'B', estado: (letra === 'B' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('C')}>
          {
            letra === 'C' ?
              <RadioButtonCheckedIcon color='primary' /> :
              <RadioButtonUncheckedIcon color='primary' />
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Alternativa (C)"
          autoComplete="off"
          multiline={true}
          value={alternativas.find(item => item.letra === 'C')?.alternativa}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'C'), { alternativa: e.target.value, letra: 'C', estado: (letra === 'C' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <Paper
        component="form"
        sx={{ p: '2px 4px', mb: 1, display: 'flex', alignItems: 'center', width: '100%', border: 'solid 1px grey' }}
      >
        <IconButton sx={{ p: '10px' }} aria-label="menu" onClick={() => setLetra('D')}>
          {
            letra === 'D' ?
              <RadioButtonCheckedIcon color='primary' /> :
              <RadioButtonUncheckedIcon color='primary' />
          }
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          autoComplete="off"
          placeholder="Alternativa (D)"
          multiline={true}
          value={alternativas.find(item => item.letra === 'D')?.alternativa}
          onChange={(e: any) => setAlternativas([...alternativas.filter(item => item.letra !== 'D'), { alternativa: e.target.value, letra: 'D', estado: (letra === 'D' ? true : false) }])}
          inputProps={{ 'aria-label': 'search google maps' }}
        />
      </Paper>

      <div className="row mt-3 mb-0">
        <div className="col-12">
          <Button onClick={() => setOpen(false)} className="float-end" >Cancelar</Button>
          <Button onClick={() => handleEditarEjercicio()} className="float-end" >Actualizar</Button>
        </div>
      </div>

    </div>
  );
}

export default FormularioEditarSM;